// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1swVq","requiredAsterisk":"Info_requiredAsterisk__1Sm6w"};